/**
 * Deutscher Textkatalog für das `community`-Feature (Foren, Threads, Halle der
 * Legenden). Schlüssel spiegeln die `t('community.*')`-Aufrufe in
 * packages/@gamecodex/world-ui/src/features/community wider.
 */
export const communityDe = {
  // CommunityPage
  'community.page.seoTitle': 'Community',
  'community.page.seoDescription':
    'Tritt der Grymwyrd-Community bei: Foren, Lore-Theorien, SL-Werkzeuge, Homebrew und die Halle der Legenden.',
  'community.page.eyebrow': 'Die aufziehende Dunkelheit',
  'community.page.title': 'Community',
  'community.page.intro':
    'Tausche Taktiken aus, spinne Theorien, teile dein Homebrew und steige zum Kanon auf. Jeder Beitrag, den du verfasst, bringt dir Münzen und Ansehen im ewigen Zwielicht.',
  'community.page.loading': 'Die Getreuen versammeln sich…',
  'community.page.forumCategories': 'Forenkategorien',
  'community.page.categoryStats': '{threads} Threads · {posts} Beiträge',
  'community.page.recentActivity': 'Letzte Aktivität',
  'community.page.liveFeed': 'Live-Feed',
  'community.page.recentEmpty':
    'Die Foren schweigen heute Nacht. Beginne eine Diskussion, um die Toten zu wecken.',
  'community.page.hallOfLegends': 'Halle der Legenden',
  'community.page.hallBlurb': 'Die größten Mitwirkenden und die Charaktere, die sie zum Kanon schmiedeten.',
  'community.page.enterTheHall': 'Betritt die Halle',
  'community.page.playerSpotlights': 'Spieler im Rampenlicht',
  'community.page.summoningLegends': 'Legenden werden beschworen…',
  'community.page.sampleNotice': 'Es werden Beispielinhalte angezeigt, während die Live-Foren erwachen.',

  // FlagButton
  'community.flag.errorQueued':
    'Wir konnten die Moderatoren gerade nicht erreichen, doch deine Meldung wurde in die Warteschlange aufgenommen.',
  'community.flag.ariaLabel': 'Diesen Beitrag zur Moderation melden',
  'community.flag.label': 'Melden',
  'community.flag.modalTitle': 'Den Wächtern melden',
  'community.flag.successDelivered':
    'Deine Meldung wurde an die Moderatoren übermittelt. Die Wächter danken dir.',
  'community.flag.close': 'Schließen',
  'community.flag.signInNotice':
    'Du kannst das Problem weiterhin beschreiben, doch du musst angemeldet sein, damit die Meldung die Moderatoren erreicht.',
  'community.flag.whyFlagging': 'Warum meldest du das?',
  'community.flag.reason.spamOrAdvertising': 'Spam oder Werbung',
  'community.flag.reason.harassmentOrAbuse': 'Belästigung oder Missbrauch',
  'community.flag.reason.spoilersWithoutWarning': 'Spoiler ohne Vorwarnung',
  'community.flag.reason.offTopic': 'Nicht zum Thema',
  'community.flag.reason.otherDescribeBelow': 'Sonstiges (unten beschreiben)',
  'community.flag.describeIssue': 'Beschreibe das Problem',
  'community.flag.detailPlaceholder': 'Sag den Wächtern, was nicht stimmt…',
  'community.flag.cancel': 'Abbrechen',
  'community.flag.reporting': 'Wird gemeldet…',
  'community.flag.submitReport': 'Meldung absenden',

  // ForumCategoryPage
  'community.category.seoTitle': '{name} — Foren',
  'community.category.seoDescription': 'Diskussionen im {name}-Forum auf Grymwyrd.',
  'community.category.breadcrumb': 'Community',
  'community.category.entityTiedPrefix': 'Entitätsgebundenes Board · Threads können verlinken zu',
  'community.category.encyclopediaEntries': 'Enzyklopädie-Einträge',
  'community.category.sampleNotice': 'Es werden Beispiel-Threads angezeigt, während das Live-Forum erwacht.',

  // HallOfLegendsPage
  'community.legends.seoTitle': 'Halle der Legenden',
  'community.legends.seoDescription':
    'Die größten Mitwirkenden von Grymwyrd und die Charaktere, die sie zum Kanon schmiedeten.',
  'community.legends.breadcrumb': 'Community',
  'community.legends.title': 'Halle der Legenden',
  'community.legends.intro':
    'Hier stehen die Baumeister des ewigen Zwielichts — die Mitwirkenden, deren Worte zum Gesetz wurden, und die Charaktere, die so geliebt waren, dass man sie in den Kanon meißelte.',
  'community.legends.loading': 'Die Kerzen werden entzündet…',
  'community.legends.topContributors': 'Top-Mitwirkende',
  'community.legends.noContributors':
    'Noch sind keine Legenden aufgestiegen. Schreibe, theoretisiere und erschaffe, um dir deinen Platz zu erobern.',
  'community.legends.canonizedCharacters': 'Kanonisierte Charaktere',
  'community.legends.noCharacters':
    'Noch wurden keine Charaktere kanonisiert. Das Bestiarium wartet auf seinen nächsten Schrecken.',
  'community.legends.sampleNotice': 'Es werden Beispiel-Legenden angezeigt, während die Live-Halle geweiht wird.',

  // NestedReplies
  'community.replies.replyBy': 'Antwort von {author}',
  'community.replies.reply': 'Antworten',
  'community.replies.replyToPlaceholder': 'Antworte {author}…',
  'community.replies.unlike': '„Gefällt mir“ zurücknehmen',
  'community.replies.like': 'Gefällt mir',

  // PlayerSpotlight
  'community.spotlight.rep': '{rep} Ansehen',
  'community.spotlight.viewInEncyclopedia': '{name} in der Enzyklopädie ansehen',

  // PostComposer
  'community.composer.placeholder': 'Erhebe deine Stimme in der Dunkelheit…',
  'community.composer.signInPrompt': 'Melde dich an, um an der Diskussion teilzunehmen und Münzen für deine Worte zu verdienen.',
  'community.composer.signInToReply': 'Zum Antworten anmelden',
  'community.composer.youFallback': 'Du',
  'community.composer.saveError':
    'Deine Antwort konnte noch nicht auf dem Server gespeichert werden — sie wird nur lokal angezeigt.',
  'community.composer.writeReply': 'Eine Antwort schreiben',
  'community.composer.writePost': 'Einen Beitrag schreiben',
  'community.composer.replyText': 'Antworttext',
  'community.composer.postText': 'Beitragstext',
  'community.composer.posting': 'Wird gepostet…',
  'community.composer.postReply': 'Antwort posten',
  'community.composer.post': 'Posten',
  'community.composer.cancel': 'Abbrechen',
  'community.composer.coinsPerPost': '+{count} Münzen pro Beitrag',
  'community.composer.coinsEarned': '+{count} Münzen für deinen Beitrag verdient!',

  // ThreadItem
  'community.thread.pinned': 'Angehefteter Thread',
  'community.thread.byPrefix': 'von',
  'community.thread.repliesTitle': '{count} Antworten',
  'community.thread.likesTitle': '{count} „Gefällt mir“',
  'community.thread.viewsTitle': '{count} Aufrufe',
  'community.thread.entityEntry': '{type}-Eintrag',

  // ThreadList
  'community.threadList.empty':
    'Hier hat sich noch keine Diskussion geregt. Sei die erste Stimme, die das Schweigen bricht.',

  // ThreadPage
  'community.threadPage.loading': 'Der Thread wird entsiegelt…',
  'community.threadPage.seoDescription': 'Eine Diskussion in den Foren der Grymwyrd-Community.',
  'community.threadPage.replyCount': '{count} Antworten',
  'community.threadPage.opened': 'eröffnet {time}',
  'community.threadPage.entityEntry': '{type}-Eintrag',
  'community.threadPage.sampleNotice': 'Es wird eine Beispieldiskussion angezeigt, während das Live-Forum erwacht.',
  'community.threadPage.openingPostBy': 'Eröffnungsbeitrag von {author}',
  'community.threadPage.repliesHeading': 'Antworten',
  'community.threadPage.noReplies': 'Noch keine Antworten. Sei die erste Stimme, die dem Ruf folgt.',
  'community.threadPage.addYourReply': 'Füge deine Antwort hinzu',
}
